import * as bootstrap from "bootstrap"
// import "bootstrap/dist/js/bootstrap.esm.js";
import "@hotwired/turbo-rails"
import "@effectiva/pure-lit-components/components/animated-count/animated-count.js";
import "@effectiva/pure-lit-components/components/timer/timer.js";
import "@effectiva/pure-lit-components/components/input-tags/input-tags.js";

import '@shoelace-style/shoelace/dist/components/avatar/avatar.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/divider/divider.js';
import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js';
import '@shoelace-style/shoelace/dist/components/menu/menu.js';
import '@shoelace-style/shoelace/dist/components/menu-item/menu-item.js';
import '@shoelace-style/shoelace/dist/components/menu-label/menu-label.js';

import '@shoelace-style/shoelace/dist/components/badge/badge.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';

import '@shoelace-style/shoelace/dist/components/copy-button/copy-button.js';

import './challenge.js';

import './features/side_menu_offcanvas.js';
import './features/flash.js';
import './features/blackbox_output_element.js';
import './features/auto_submit_form_on_visit.js';
import './features/keyboard_shortcuts.js';
import './features/swipe_card_element.js';
import './features/screening_ui.js';


/* Cookie policy */
document.addEventListener("click", (event) => {
  const button = event.target.closest("#cookie_policy_banner button");

  if (!button) return;

  localStorage.setItem("cookie_policy_accepted", "true");
  document.documentElement.classList.toggle("cookie-policy-accepted", true);

  Turbo.cache.clear();
});


document.addEventListener("turbo:load", () => {
  const accepted = localStorage.getItem("cookie_policy_accepted") === "true";
  document.documentElement.classList.toggle("cookie-policy-accepted", accepted);
});


/* Clean up flash messages after animation */
document.addEventListener("animationend", (event) => {
  const element = event.target.closest(".js-auto-hide");
  element?.remove()
});




document.addEventListener('click', ({target}) => {
  if (!target.matches('.js-close')) return;

  const container = target.closest('#notifications_banner');
  container?.remove();
});


// Indicator for more questions in scroll when answering a question
const intersectionObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    const { visibilityTarget } = entry.target.dataset;
    document.getElementById(visibilityTarget)?.classList.toggle('is-visible', !entry.isIntersecting);
  });
});

document.addEventListener("turbo:load", () => {
  document.querySelectorAll('.js-observe').forEach((element) => {
    intersectionObserver.observe(element);
  });
});
